/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import { MdCleaningServices } from 'react-icons/md';

import PropTypes from 'prop-types';
import { useQueryState } from 'use-location-state';

import { Tab, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import CardSideBordered from '~/components/CardSideBordered';
import LocaleMessage from '~/components/LocaleMessage';

import Page404 from '~/pages/Open/Page404';

import Settings from './Settings';

const useStyles = makeStyles(() => ({
    tabs: {
        marginTop: '10px',
        textAlign: 'left',
    },
}));

const tab_settings = [
    {
        label: <LocaleMessage msg="page.applications.cleaning.tabs.settings" />,
        value: 'settings',
    },
];

const pages = {
    settings: Settings,
};

/**
 * Main module for Cleaning Application configuration.
 * Orchestrates different configuration tabs (currently Settings).
 */
export default function CleaningApp({
    setToast,
    appSettings,
    updateObject,
    location,
}) {
    const classes = useStyles();
    const [queryTab, setQueryTab] = useQueryState('tab', 'settings');
    const [value, setValue] = useState(queryTab || tab_settings[0].value);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        if (location.search !== newValue) {
            setQueryTab(newValue);
        }
    };

    function renderInternalPage(page) {
        const Page = pages[page] || Page404;
        return (
            <Page
                updateObject={updateObject}
                app={appSettings}
                setToast={setToast}
            />
        );
    }

    return (
        <div className="col-12 mb-5 mt-5">
            <CardSideBordered
                title={<LocaleMessage msg="page.applications.cleaning.title" />}
                Icon={MdCleaningServices}
                hide
            >
                <div className="sidecard-body">
                    <Tabs
                        indicatorColor="primary"
                        value={value || 'settings'}
                        onChange={handleChangeTab}
                        className={classes.tabs}
                        centered
                    >
                        {tab_settings.map(s => (
                            <Tab
                                key={s.value}
                                label={s.label}
                                value={s.value}
                            />
                        ))}
                    </Tabs>

                    <div style={{ flex: 1 }}>{renderInternalPage(value)}</div>
                </div>
            </CardSideBordered>
        </div>
    );
}

CleaningApp.propTypes = {
    appSettings: PropTypes.object.isRequired,
    updateObject: PropTypes.func.isRequired,
    setToast: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
};
